import { IsObject } from '../../helpers';
import { ReadonlyTuple } from '../readonly-tuple/implementation';
import { READONLY_TUPLE_PRIVATE } from '../readonly-tuple/privates';
export function IsReadonlyList(value) {
    return IsObject(value)
        && (value instanceof ReadonlyList);
}
export class ReadonlyList extends ReadonlyTuple {
    constructor(iterable) {
        super(Array.isArray(iterable) ? iterable : Array.from(iterable));
    }
    concat(...items) {
        return this[READONLY_TUPLE_PRIVATE].items.concat(...items);
    }
    reverse() {
        return this[READONLY_TUPLE_PRIVATE].items.slice().reverse();
    }
    slice(start, end) {
        return this[READONLY_TUPLE_PRIVATE].items.slice(start, end);
    }
    sort(compareFn) {
        return this[READONLY_TUPLE_PRIVATE].items.slice().sort();
    }
    every(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.every(callback, thisArg);
    }
    some(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.some(callback, thisArg);
    }
    forEach(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.forEach(callback, thisArg);
    }
    map(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.map(callback, thisArg);
    }
    filter(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.filter(callback, thisArg);
    }
    reduce(callback, initialValue) {
        return this[READONLY_TUPLE_PRIVATE].items.reduce(callback, initialValue);
    }
    reduceRight(callback, initialValue) {
        return this[READONLY_TUPLE_PRIVATE].items.reduceRight(callback, initialValue);
    }
    flatMap(callback, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.flatMap(callback, thisArg);
    }
    flat(depth) {
        return this[READONLY_TUPLE_PRIVATE].items.flat(depth);
    }
}
//# sourceMappingURL=implementation.js.map